const GTM_ID = "GTM-MXT7M59P";
const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

let gtmRequested = false;
let lazyInitRegistered = false;

const loadGtm = () => {
    if (gtmRequested || typeof window === "undefined" || typeof document === "undefined") {
        return;
    }

    gtmRequested = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
    });

    const script = document.createElement("script");
    script.async = true;
    script.src = GTM_SRC;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
};

const scheduleAfterLoad = () => {
    const scheduleIdle = () => {
        const isMobile = window.matchMedia?.("(max-width: 767px)").matches;

        if (isMobile) {
            window.setTimeout(loadGtm, 15000);
            return;
        }

        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(loadGtm, { timeout: 3000 });
            return;
        }

        window.setTimeout(loadGtm, 1500);
    };

    if (document.readyState === "complete") {
        scheduleIdle();
        return;
    }

    window.addEventListener("load", scheduleIdle, { once: true });
};

export const initLazyAnalytics = () => {
    if (lazyInitRegistered || typeof window === "undefined" || typeof document === "undefined") {
        return;
    }

    lazyInitRegistered = true;

    window.addEventListener("pointerdown", loadGtm, { once: true, passive: true });
    window.addEventListener("keydown", loadGtm, { once: true });
    scheduleAfterLoad();
};
